import Component from "./Company";
export default Component;
